import React from 'react'
import { Button, Card, Form, InputNumber, Select, Space } from 'antd'
import { useSelect } from '@refinedev/antd'
import { RowRemoveButton } from 'components/button'
import { IAttribute, IAttributeRelation } from 'interfaces/attribute'
import { IMAGE, REQUIRES_OPTIONS } from 'consts'
import { file2Base64 } from '@refinedev/core'

interface AttributeMappingFormProps {
  name?: string
  initialRelations?: IAttributeRelation[]
  relationField?: string
}

export const AttributeMappingForm: React.FC<AttributeMappingFormProps> = ({
  name = 'attributes',
  relationField,
}) => {
  const { selectProps } = useSelect<IAttribute>({
    resource: 'core/attributes',
    optionLabel: 'name',
    optionValue: 'id',
    pagination: { mode: 'off' },
  })

  return (
    <Card title="Attribute Mappings">
      <Form.List name={name}>
        {(fields, { add, remove }) => (
          <>
            {fields.map((field) => (
              <Space
                key={field.key}
                style={{ display: 'flex' }}
                align="baseline">
                <Form.Item name={[field.name, 'order']}>
                  <InputNumber
                    placeholder="Order"
                    min={1}
                    style={{ width: 100 }}
                  />
                </Form.Item>
                <Form.Item
                  name={[field.name, 'attribute']}
                  rules={[{ required: true, message: 'Attribute required' }]}>
                  <Select
                    {...selectProps}
                    placeholder="Select Attribute"
                    style={{ width: 300 }}
                  />
                </Form.Item>
                <RowRemoveButton onClick={() => remove(field.name)} />
              </Space>
            ))}
            <Form.Item>
              <Button type="dashed" onClick={() => add()} block>
                Add Attribute
              </Button>
            </Form.Item>
          </>
        )}
      </Form.List>
    </Card>
  )
}

export const handleAttributeValues = async (values: any) => {
  const attributesWithValue = []
  for (let key in values) {
    if (key.match(/^generated_/)) {
      const keySplit = key.split('_')
      const type = keySplit[3]
      let valueOptions:
        | ({ [s: string]: unknown } | ArrayLike<unknown>)[]
        | { option: any }[] = []
      let images = []

      // build option values
      if (REQUIRES_OPTIONS.includes(type)) {
        if (Array.isArray(values[key]))
          valueOptions = values[key].map((value: string) => ({
            option: value,
          }))
        else valueOptions.push({ option: values[key] })
        values[key] = null
      }

      // build images to send back
      if (type === IMAGE && values[key]) {
        for (let imgObj of values[key]) {
          if (imgObj.originFileObj) {
            const base64String = await file2Base64(imgObj)
            images.push({ image: base64String })
          } else {
            images.push({ id: imgObj.id ?? imgObj.uid })
          }
        }
      }

      const finalValue: { [key: string]: any } = {
        attribute: keySplit[2],
        value: String(values[key]),
        value_options: valueOptions,
        images,
      }
      if (keySplit[1] !== 'undefined') finalValue['id'] = keySplit[1]
      // if there is no value or no valueOption selected do not add that attribute
      // to the payload
      if (
        values[key] ||
        (valueOptions.length &&
          Object.keys(valueOptions[0]).length &&
          Object.values(valueOptions[0])[0])
      ) {
        attributesWithValue.push(finalValue)
      }
      delete values[key]
    }
  }
  return attributesWithValue
}
